/**
 * MercadoPago Service - Handles all MercadoPago related operations
 */

export const createMercadoPagoPreference = async (orderData, token) => {
   const { newOrder, mp_url,cartObras, userRecord, dirRecord, totalAmount } =
   orderData;
   console.log('createMercadoPagoPreference 1: ', mp_url.success);
   console.log('createMercadoPagoPreference 2: ', mp_url.failure);
   console.log('createMercadoPagoPreference 3: ', mp_url.pending);

   // Prepare MercadoPago data structure
   const MercadoPagoData = {
      pedido_id: newOrder ? newOrder.id : null,
      external_reference: newOrder ? newOrder.id : null,
      total: totalAmount,
      currency_id: "ARS",
      items: cartObras.map((obra) => ({
         id: obra.id.toString(),
         title: obra.titulo,
         description: `Medidas: ${obra.medidas}`,
         quantity: 1,
         unit_price: Number(obra.precio || 0),
         currency_id: "ARS",
      })),
      payer: {
         name: userRecord.nombre,
         email: userRecord.email,
         phone: {
            area_code: "",
            number: userRecord.celular || "",
         },
         address: {
            street_name: dirRecord.calle || "",
            city_name: dirRecord.ciudad || "",
            state_name: dirRecord.provincia || "",
            zip_code: dirRecord.codigo_postal || "",
         },
      },
      back_urls: {
         success: mp_url.success || `${window.location.origin}/pages/mercadopago/success`,
         failure: mp_url.failure || `${window.location.origin}/pages/mercadopago/failure`,
         pending: mp_url.pending || `${window.location.origin}/pages/mercadopago/pending`,
      },
      auto_return: "approved",
      payment_methods: {
         excluded_payment_methods: [],
         excluded_payment_types: [],
         installments: 12,
      },
      shipments: {
         mode: "not_specified",
      },
   };

   // console.log(
   //    "🚀 Sending MercadoPago request to:",
   //    "mercadopago-create endpoint"
   // );
   console.log("📦 Request data:", JSON.stringify(MercadoPagoData, null, 2));
   console.log('MercadoPagoData: ', MercadoPagoData.back_urls.success);
   // console.log("🔑 Using token:", token ? "Token present" : "Token missing");
 

   try {
      const response = await fetch(
         `${process.env.REACT_APP_SUPABASE_URL}/functions/v1/mercado_pago`,
         {
            method: "POST",
            headers: {
               Authorization: `Bearer ${token}`,
               "Content-Type": "application/json",
               Accept: "application/json",
            },
            body: JSON.stringify(MercadoPagoData),
            referrerPolicy: "strict-origin-when-cross-origin",
         }
      );

      console.log("📡 Response status:", response);
      console.log(
         "📋 Response headers:",
         Object.fromEntries(response.headers.entries())
      );

      if (!response.ok) {
         let errorMessage = `HTTP error! status: ${response.status}`;

         // Try to get error details from response
         try {
            const errorData = await response.text();
            console.error("❌ Error response body:", errorData);

            // Try to parse as JSON for more details
            try {
               const errorJson = JSON.parse(errorData);
               errorMessage =
                  errorJson.error || errorJson.message || errorMessage;
            } catch (e) {
               // If not JSON, use the text as is
               errorMessage = errorData || errorMessage;
            }
         } catch (e) {
            console.error("❌ Could not read error response:", e);
         }

         // Specific error handling based on status
         const statusErrorMessages = {
            405: "Method Not Allowed - Check if your Supabase Edge Function handles POST requests correctly",
            401: "Unauthorized - Check your Supabase token",
            403: "Forbidden - Check your function permissions",
            404: "Not Found - Check if the function 'mercadopago-create' exists",
            500: "Internal Server Error - Check your function logs in Supabase dashboard",
         };

         errorMessage = statusErrorMessages[response.status] || errorMessage;
         throw new Error(errorMessage);
      }

      // Try to parse the response
      let mpResult;
      try {
         const responseText = await response.text();
         mpResult = JSON.parse(responseText);
         console.log("✅ Parsed response:", mpResult);
      } catch (parseError) {
         console.error("❌ Error parsing response:", parseError);
         throw new Error("Invalid response format from MercadoPago service");
      }

      console.log("mpResult.success: ", mpResult.success);

      // Check for success in response
      if (mpResult.init_point) {
         console.log("🎉 MercadoPago preference created successfully!");
         console.log("🔗 Init point:", mpResult.init_point);

         return {
            success: true,
            init_point: mpResult.init_point,
            preference_id: mpResult.id,
            data: mpResult,
         };
      } else {
         console.error("❌ MercadoPago error:", mpResult);
         throw new Error(
            mpResult.error ||
               mpResult.message ||
               "Error creating MercadoPago preference"
         );
      }
   } catch (fetchError) {
      console.error("❌ Fetch error:", fetchError);

      // Network or other fetch-related errors
      if (
         fetchError.name === "TypeError" &&
         fetchError.message.includes("fetch")
      ) {
         throw new Error(
            "Network error - Check your internet connection and Supabase URL"
         );
      }

      // Re-throw the error to be caught by the outer try-catch
      throw fetchError;
   }
};

/**
 * Redirect to MercadoPago checkout
 * @param {string} initPoint - The MercadoPago init_point URL
 * @param {boolean} openInNewTab - Whether to open in new tab or redirect current page
 */
export const redirectToMercadoPago = (initPoint, openInNewTab = true) => {
   if (openInNewTab) {
      window.open(initPoint, "_blank");
   } else {
      window.location.href = initPoint;
   }
};

/**
 * Create MercadoPago preference and redirect
 * @param {Object} orderData - Order data including cartObras, userRecord, etc.
 * @param {string} token - Supabase token
 * @param {boolean} openInNewTab - Whether to open checkout in new tab
 * @returns {Promise<Object>} Result object with success status
 */
export const processPayment = async (orderData, token, openInNewTab = true) => {
   try {
      const result = await createMercadoPagoPreference(orderData, token);

      if (result.success) {
         redirectToMercadoPago(result.init_point, openInNewTab);
         return {
            success: true,
            message: "Redirecting to MercadoPago checkout...",
            data: result.data,
         };
      } else {
         return {
            success: false,
            message: "Failed to create MercadoPago preference",
            error: result.error,
         };
      }
   } catch (error) {
      console.error("❌ Payment processing error:", error);
      return {
         success: false,
         message: `Payment processing failed: ${error.message}`,
         error: error.message,
      };
   }
};

/**
 * Validate MercadoPago data before sending
 * @param {Object} orderData - Order data to validate
 * @returns {Object} Validation result
 */
export const validateMercadoPagoData = (orderData) => {
   const { cartObras, userRecord, dirRecord, totalAmount } = orderData;
   const errors = [];

   // Validate cart
   if (!cartObras || cartObras.length === 0) {
      errors.push("Cart is empty");
   }

   // Validate user data
   if (!userRecord.nombre?.trim()) {
      errors.push("User name is required");
   }
   if (!userRecord.email?.trim()) {
      errors.push("User email is required");
   }

   // Validate address
   if (!dirRecord.calle?.trim()) {
      errors.push("Street address is required");
   }
   if (!dirRecord.ciudad?.trim()) {
      errors.push("City is required");
   }
   if (!dirRecord.provincia?.trim()) {
      errors.push("Province is required");
   }
   if (!dirRecord.codigo_postal?.trim()) {
      errors.push("Postal code is required");
   }

   // Validate total
   if (!totalAmount || totalAmount <= 0) {
      errors.push("Total amount must be greater than 0");
   }
   const resp = {
      isValid: errors.length === 0,
      errors,
   };
   return resp;
};

export default {
   createMercadoPagoPreference,
   redirectToMercadoPago,
   processPayment,
   validateMercadoPagoData,
};
